<div class="tw-sticky tw-top-0 tw-z-[100] tw-flex tw-justify-between tw-items-center tw-h-14 tw-pl-2 tw-pr-4 tw-bg-gray-800">
  <div class="tw-flex tw-items-center">
    <div class="tw-flex tw-justify-center tw-items-center tw-p-2">
      <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
               [iconName]="'arrow_back'"
               (click)="back.emit()"></cs-icon>
    </div>
    @if (isRegimenExpired()) {
      <span class="tw-font-lexend tw-font-normal tw-text-gray-50"
            [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}">Get Your Treatment</span>
    } @else {
      @if (regimenClass() === RegimenClass.FACE) {
        <span class="tw-font-lexend tw-font-normal tw-text-gray-50"
              [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}"
              i18n="@@discoverClearSkin">Discover clear skin</span>
      }
      @if (regimenClass() === RegimenClass.HAIR) {
        <span class="tw-font-lexend tw-font-normal tw-text-gray-50"
              [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}"
              i18n="@@discoverHealthyHair">Discover healthy hair</span>
      }
    }
  </div>
  <div class="tw-flex tw-items-center">
    <chat-language-pill [consultationSession]="consultationSession()"
                        [botReplyInProgress]="botReplyInProgress()"
                        [translateChatMessages]="translateChatMessages()"></chat-language-pill>
  </div>
</div>
